import { useCallback, useEffect, useRef, useState } from "react";
import { wsUrl, refreshSession } from "@/lib/api";

export function useRoomSocket(roomId, handlers) {
  const ws = useRef(null);
  const h = useRef(handlers);
  h.current = handlers;
  const [status, setStatus] = useState("connecting");
  const [rtt, setRtt] = useState(null);

  useEffect(() => {
    let stopped = false;
    let retry;
    let ping;
    let refreshed = false;
    const connect = () => {
      const s = new WebSocket(wsUrl(`/ws/rooms/${roomId}`));
      ws.current = s;
      s.onopen = () => {
        refreshed = false;
        setStatus("online");
        h.current.open?.();
        ping = setInterval(() => s.readyState === 1 && s.send(JSON.stringify({ type: "ping", t: performance.now() })), 5000);
      };
      s.onmessage = (e) => {
        const d = JSON.parse(e.data);
        if (d.type === "pong") setRtt(Math.round(performance.now() - d.t));
        else h.current[d.type]?.(d);
      };
      s.onclose = (e) => {
        clearInterval(ping);
        if (e.code === 4401 && !stopped && !refreshed) {
          refreshed = true;
          refreshSession().then(connect).catch(() => setStatus("offline"));
          return;
        }
        if (stopped || e.code === 4403 || e.code === 4401) {
          setStatus(e.code === 4403 ? "closed" : "offline");
          return;
        }
        setStatus("reconnecting");
        retry = setTimeout(connect, 2000);
      };
    };
    connect();
    return () => {
      stopped = true;
      clearTimeout(retry);
      clearInterval(ping);
      ws.current?.close();
    };
  }, [roomId]);

  const send = useCallback((obj) => ws.current?.readyState === 1 && ws.current.send(JSON.stringify(obj)), []);
  return { status, rtt, send };
}
